<template>
<section>
    <section class=" tw-py-48 tw-bg-center tw-relative tw-bg-cover" :style="{'background-image': `url(${pageOptions ? !pageOptions.custom_highlight ? (singles[0] ? singles[0].images[0].url : albums[0].images[0].url) : isVideo == false ? pageOptions ? (pageOptions.featured_img ? '/'+pageOptions.featured_img : singles[0] ? singles[0].images[0].url : albums[0].images[0].url) : singles[0] ? singles[0].images[0].url : albums[0].images[0].url : '' : singles[0] ? singles[0].images[0].url : albums[0].images[0].url})`}" id="banner">
        <div class="tw-absolute tw-w-full tw-h-full tw-overflow-hidden tw-top-0 tw-left-0" v-if="isVideo == true">
            <video :src="'/'+pageOptions.featured_img" class="full" autoplay muted loop playsinline></video>
        </div>
        <div class="tw-container tw-mx-auto tw-h-full tw-relative tw-z-20">
            <div class="tw-flex tw-flex-wrap tw-items-end tw-justify-center tw-h-full tw-relative">
                <div class="tw-block tw-w-full tw-text-center tw-relative tw-pb-16">
                    <!-- <v-btn class="ma-2" small fab outlined >
                        <v-icon class="tw-text-sm">fas fa-play</v-icon>
                    </v-btn> -->
                    <p class="tw-font-sans tw-text-white tw-font-light tw-text-sm lg:tw-text-xl tw-text-center tw-p-0 tw-mt-3 tw-mb-0 tw-uppercase tw-tracking-widest">{{pageOptions ? !pageOptions.custom_highlight ? (selectedLanguageObj.check_now) : (pageOptions.featured_subtitle ? pageOptions.featured_subtitle : (selectedLanguageObj.check_now)) : (selectedLanguageObj.check_now)}}</p>
                    <h1 class="tw-font-sans tw-text-white tw-font-extrabold tw-text-3xl lg:tw-text-5xl tw-text-center tw-m-0 tw-uppercase">{{pageOptions ? !pageOptions.custom_highlight ? singles[0] ? singles[0].name : albums[0].name : (pageOptions.featured_title ? pageOptions.featured_title : singles[0] ? singles[0].name : albums[0].name) : singles[0] ? singles[0].name : albums[0].name}}</h1>
                    <v-btn depressed small color="white" :target="pageOptions ? !pageOptions.custom_highlight ? '_blank' : (pageOptions.featured_url ? '_blank' : '_self') : '_self'" :href="pageOptions ? !pageOptions.custom_highlight ? singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}` : (pageOptions.featured_url ? pageOptions.featured_url : singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}`) : singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}`" light class="tw-font-sans tw-mt-5"><v-icon left class="tw-text-xs">fas fa-play</v-icon> {{pageOptions ? !pageOptions.custom_highlight ? (selectedLanguageObj.sub_check) : (pageOptions.button_text ? pageOptions.button_text : (selectedLanguageObj.sub_check)) : (selectedLanguageObj.sub_check)}}</v-btn>
                </div> 
                <i class="fas fa-chevron-down tw-text-white tw-text-2xl tw-absolute tw-bottom-0 tw--mb-2"></i>
            </div>
        </div>
    </section>
    <section id="musics" class="tw-items-center tw-py-8 tw-mb-16 tw-z-20 tw-relative" v-if="Object.keys(singles).length">
        <div class="tw-container tw-mx-auto tw-relative tw--mt-56">
            <div class="tw-flex tw-items-center tw-justify-center tw-flex-wrap">
                <div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-px-4 md:tw-px-0">
                    <h6 class="tw-text-white tw-font-sans">Singles</h6>
                    <div class="tw-space-x-2 tw-text-xl tw-hidden lg:tw-flex">
                        <i class="fas fa-chevron-circle-left tw-text-white swiper-button-prev tw-cursor-pointer tw-outline-none"></i>
                        <i class="fas fa-chevron-circle-right tw-text-white swiper-button-next tw-cursor-pointer tw-outline-none"></i>
                    </div>
                </div>
                <div class="swiper-container tw-w-full tw-mt-5">
                    <!-- Additional required wrapper -->
                    <div class="swiper-wrapper">
                        <!-- Slides -->
                        <single class="swiper-slide" v-for="(single, index) in singles" :single="single" :artist="artist" :spotifyArtist="spotifyArtist" :key="index" />                                             
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="albums" class="tw-items-center tw-py-16 tw-mt-16" v-if="Object.keys(albums).length">
        <div class="tw-container tw-mx-auto tw-relative">
            <div class="tw-flex tw-items-center tw-justify-center tw-flex-wrap">
                <div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-px-4 md:tw-px-0">
                    <h6 class="tw-text-white tw-font-sans">{{selectedLanguage == 'US' ? en.last_album : pt.last_album}}</h6>
                    <div class="tw-space-x-2 tw-text-xl tw-hidden lg:tw-flex">
                        <i class="fas fa-chevron-circle-left tw-text-white swiper-button-prev tw-cursor-pointer tw-outline-none"></i>
                        <i class="fas fa-chevron-circle-right tw-text-white swiper-button-next tw-cursor-pointer tw-outline-none"></i>
                    </div>
                </div>
                <div class="swiper-container tw-w-full tw-mt-5">
                    <!-- Additional required wrapper -->
                    <div class="swiper-wrapper">
                        <!-- Slides -->
                        <div class="swiper-slide" v-for="album in albums" :key="album.id">
                            <v-img :src="album.images[0].url" class="tw-shadow-lg tw-rounded-md tw-border tw-border-gray-900" aspect-ratio="1">
                                <inertia-link :href="tenant ? `/album/${album.id}` : `/album/${artist.artista_url}/${album.id}`" class="tw-w-full tw-h-full tw-absolute tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider" style="background:rgba(0,0,0,0.6)">
                                    <div class="tw-block tw-px-5 tw-truncate tw-w-full" style="margin-bottom: 132px">
                                        <h6 class="tw-uppercase tw-font-sans tw-text-white tw-font-bold tw-p-0 tw-truncate tw-m-0">{{album.name}}</h6>
                                        <div class="tw-font-sans tw-text-white tw-font-semibold tw-w-full tw-text-xs tw-truncate">
                                            <span v-for="(artist, index) in album.artists" :key="artist.id">
                                                <span>{{artist.name}}</span>
                                                <span v-if="index !== album.artists.length - 1" class="tw--ml-1 tw-mr-1">,</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-flex-wrap tw-items-center tw-justify-center tw-text-center tw-flex single-slider">
                                        <v-btn class="ma-2" outlined large fab color="white">
                                            <v-icon>fas fa-play</v-icon>
                                        </v-btn>
                                    </div>
                                </inertia-link>
                            </v-img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div id="about" class="tw-shadow-md" v-if="artist.options.bio">
        <div class="background">
            <picture class="tw-w-full tw-h-full tw-object-cover tw-object-center tw-block">
                <source :srcset="pageOptions ? (pageOptions.bio_image ? '/'+pageOptions.bio_image : spotifyArtist.images[0].url) : spotifyArtist.images[0].url">
                <img :src="pageOptions ? (pageOptions.bio_image ? '/'+pageOptions.bio_image : spotifyArtist.images[0].url) : spotifyArtist.images[0].url" class="tw-w-full tw-h-full tw-object-cover tw-object-center tw-block" alt="">
            </picture>
        </div>
        <div class="tw-container tw-mx-auto tw-relative">
            <div class="tw-w-full md:tw-w-6/12 tw-py-16 tw-px-8 md:tw-px-0">
                <img :src="artist.post_image" v-if="artist.post_image" class="tw-w-24 tw-mb-8 tw-mx-auto md:tw-m-0" alt="">
                <div class="tw-flex tw-items-center tw-mb-6 tw-mt-3 tw-space-x-5 tw-justify-center md:tw-justify-start">
                    <a target="_blank" :href="'https://www.youtube.com/channel/'+artist.options.youtubeUrl" v-if="artist.options.youtubeUrl && artist.options.youtubeUrl !== '#'" class="hover:tw-opacity-50 tw-transition-all tw-duration-300"><img src="/imgs/youtube-home.png" alt="" class="tw-w-12 md:tw-w-auto" /></a>
                    <a target="_blank" :href="'https://open.spotify.com/artist/'+artist.options.spotifyUrl" v-if="artist.options.spotifyUrl && artist.options.spotifyUrl !== '#'" class="hover:tw-opacity-50 tw-transition-all tw-duration-300"><img src="/imgs/spotify-home.png" alt="" class="tw-w-12 md:tw-w-auto" /></a>
                </div>
                <p class="tw-font-sans tw-text-sm tw-text-white tw-font-light tw-leading-loose bio tw-overflow-hidden tw-relative truncated tw-whitespace-pre-wrap" v-html="artist.options.bio"></p>
            </div>
        </div>
    </div>
    <section id="playlists" class="tw-items-center tw-py-16 tw-mt-16" v-if="Object.keys(playlists).length">
        <div v-if="loading" class="tw-flex tw-justify-center tw-items-center tw-w-full">
            <v-progress-circular indeterminate color="#5A3273"></v-progress-circular>
        </div>
        <playlist-list :playlists="playlists"></playlist-list>
    </section>
    <section id="shows" class="tw-py-8 tw-mb-12" v-if="Object.keys(shows).length">
        <div class="tw-container tw-mx-auto">
            <div class="tw-flex tw-w-full tw-items-center tw-px-4 md:tw-px-0">
                <h6 class="tw-text-white tw-font-sans">{{selectedLanguage == 'US' ? en.title_show_schedule : pt.title_show_schedule}}</h6>
            </div>
            <div class="tw-flex tw-flex-col tw-mt-3">
                <div class="tw-border-b tw-border-gray-700 tw-px-4 md:tw-px-0" v-for="(show, index) in shows" :key="index">
                    <div class="tw-flex tw-flex-row">
                        <div class="tw-flex tw-flex-row tw-flex-grow tw-border-l-0 tw-h-auto event-wrapper">
                            <div class="tw-flex tw-flex-1 tw-flex-col md:tw-flex-row">
                                <div class="event-date">
                                    <div class="tw-font-sans tw-text-base tw-leading-5 tw-mr-3 md:tw-mr-0 tw-text-white tw-font-black tw-uppercase">
                                        {{ new Intl.DateTimeFormat('en-us', {day: 'numeric'}).format(new Date(addDays(show.date, 1))) }}
                                        {{ new Intl.DateTimeFormat('pt-br', {month: 'short'}).format(new Date(addDays(show.date, 1))) }}
                                    </div>
                                    <div class="tw-font-sans tw-text-sm tw-leading-5 tw-mr-0 tw-text-white tw-font-light">
                                        {{new Intl.DateTimeFormat('pt-br', {weekday: 'short'}).format(new Date(addDays(show.date, 1))) }}
                                        {{ show.date ? ' • ' + new Intl.DateTimeFormat('pt-br', {hour: "numeric", minute: "numeric"}).format(new Date(addDays(show.date, 1))) : '' }}</div>
                                </div>
                                <div class="tw-flex tw-flex-1 tw-flex-row">
                                    <div class="event-details">
                                        <div class="event-details__header">
                                            <div class="event-details__inner tw-truncate">
                                                <div class="tw-block tw-w-full">
                                                    <div class="tw-font-sans tw-truncate tw-text-white tw-text-base tw-leading-5">{{show.title}}</div>
                                                    <div class="tw-font-sans tw-truncate tw-text-white tw-font-light tw-text-sm tw-leading-5">{{show.location}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-actions tw-hidden xl:tw-flex">
                            <a :href="show.link" v-if="show.link" target="_blank" v-ripple>{{selectedLanguage == 'US' ? en.ticket : pt.ticket}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="pressKit" class="tw-py-8 tw-w-full" v-if="pageOptions && (pageOptions.technical_kit_link || pageOptions.press_kit_link)">
        <div class="tw-container tw-mx-auto">
            <div class="tw-flex tw-flex-wrap tw-items-center tw-mb-3">
                <div class="tw-w-full tw-text-center tw-justify-center tw-mb-5 md:tw-mb-0" :class="{'md:tw-w-6/12': pageOptions.press_kit_link , 'md:tw-w-full': !pageOptions.press_kit_link }" v-if="pageOptions.technical_kit_link">
                    <h3 class="tw-text-white tw-font-sans tw-font-bold tw-m-0 tw-text-3xl">{{selectedLanguage == 'US' ? en.title_kit : pt.title_kit}}</h3>
                    <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3">{{selectedLanguage == 'US' ? en.sub_title_kit : pt.sub_title_kit}}</div>
                    <v-dialog v-model="technical" max-width="450" transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="white"  v-on="on" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3" light>
                                Download
                            </v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="purple">
                                <v-btn icon dark small class="tw-ml-1" @click="technical = false">
                                    <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                </v-btn>
                                <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguage == 'US' ? en.title_kit : pt.title_kit}}</v-toolbar-title>
                            </v-toolbar>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.technical_kit_password ? !technical_free : false">
                                <h4 class="tw-text-white tw-font-sans tw-font-bold tw-text-xl tw-m-0"> {{selectedLanguage == 'US' ? en.file_protected_title : pt.file_protected_title}}</h4>
                                <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3 tw-text-sm">{{selectedLanguage == 'US' ? en.file_protected_title_input : pt.file_protected_title_input}}</div>
                                <div class="tw-py-3 tw-px-3 tw-m-0 tw-h-auto tw-rounded tw-bg-black tw-flex-1 tw-min-w-full tw-flex">
                                    <input type="password" v-model="technical_password" class="tw-font-sans tw-text-white tw-m-0 tw-h-auto tw-rounded tw-text-sm tw-bg-black tw-border-0 focus:tw-shadow-none tw-flex-1 tw-min-w-full tw-flex">
                                </div>
                                <v-btn block class="tw-mt-3 tw-text-xs tw-tracking-widest tw-font-sans" color="purple" dark @click="verifyPassword('technical')">{{selectedLanguage == 'US' ? en.file_protected_bt : pt.file_protected_bt}}</v-btn>
                            </div>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.technical_kit_password ? technical_free : true">
                                <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                    <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ pageOptions.technical_kit_link }}</div>
                                    <a :href="pageOptions.technical_kit_link" target="_blank" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>Abrir</a>
                                </div>
                            </div>
                        </v-card>
                    </v-dialog>
                </div>
                <div class="tw-w-full tw-text-center tw-justify-center" :class="{'md:tw-w-6/12': pageOptions.technical_kit_link, 'md:tw-w-full': !pageOptions.technical_kit_link }" v-if="pageOptions.press_kit_link">
                    <h3 class="tw-text-white tw-font-sans tw-font-bold tw-m-0 tw-text-3xl">{{selectedLanguage == 'US' ? en.title_kit_press : pt.title_kit_press}}</h3>
                    <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3">{{selectedLanguage == 'US' ? en.sub_title_kit : pt.sub_title_kit}}</div>
                    <v-dialog v-model="press" max-width="450" transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="white"  v-on="on" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3" light>
                                Download
                            </v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="purple">
                                <v-btn icon dark small class="tw-ml-1" @click="press = false">
                                    <v-icon class="tw-text-sm">fas fa-times</v-icon>
                                </v-btn>
                                <v-toolbar-title class="tw-font-sans tw-pl-2">{{selectedLanguage == 'US' ? en.title_kit_press : pt.title_kit_press}}</v-toolbar-title>
                            </v-toolbar>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.press_kit_password ? !press_free : false">
                                <h4 class="tw-text-white tw-font-sans tw-font-bold tw-text-xl tw-m-0">{{selectedLanguage == 'US' ? en.file_protected_title : pt.file_protected_title}}</h4>
                                <div class="tw=text=sm tw-opacity-40 tw-text-white tw-font-sans tw-mb-3 tw-text-sm">{{selectedLanguage == 'US' ? en.file_protected_title_input : pt.file_protected_title_input}}</div>
                                <div class="tw-py-3 tw-px-3 tw-m-0 tw-h-auto tw-rounded tw-bg-black tw-flex-1 tw-min-w-full tw-flex">
                                    <input type="password" v-model="press_password" class="tw-font-sans tw-text-white tw-m-0 tw-h-auto tw-rounded tw-text-sm tw-bg-black tw-border-0 focus:tw-shadow-none tw-flex-1 tw-min-w-full tw-flex">
                                </div>
                                <v-btn block class="tw-mt-3 tw-text-xs tw-tracking-widest tw-font-sans" color="purple" dark @click="verifyPassword('press')">{{selectedLanguage == 'US' ? en.file_protected_bt : pt.file_protected_bt}}</v-btn>
                            </div>
                            <div class="tw-px-2 tw-py-4 tw-w-full" v-if="pageOptions.press_kit_password ? press_free : true">
                                <div class="tw-w-full tw-flex tw-items-center tw-py-2 tw-px-3 tw-border tw-rounded tw-justify-between" id="shareLink">
                                    <div class="tw-mr-4 tw-text-sm tw-font-light tw-truncate tw-font-sans tw-opacity-40 tw-cursor-default tw-pointer-events-none">{{ pageOptions.press_kit_link }}</div>
                                    <a :href="pageOptions.press_kit_link" target="_blank" class="tw-h-full tw-px-6 tw-py-2 tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-font-sans tw-uppercase tw-text-xs tw-whitespace-no-wrap tw-rounded" v-ripple>Abrir</a>
                                </div>
                            </div>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
        </div>
        <v-snackbar v-model="snackbar" :multi-line="false" right top>
            {{ snackbar_text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="red" text v-bind="attrs" @click="snackbar = false">{{selectedLanguage == 'US' ? en.close : pt.close}}</v-btn>
            </template>
        </v-snackbar>
    </section>
    <section id="contact" class="tw-py-8 tw-w-full" v-if="pageOptions && (pageOptions.email || pageOptions.contractor_email || pageOptions.contractor_phone)">
        <div class="tw-container tw-mx-auto tw-flex tw-flex-wrap">
            <div :class="{'tw-mb-10 md:tw-mb-0 md:tw-w-6/12': pageOptions.contractor_email || pageOptions.contractor_phone}" class="tw-w-full tw-items-center tw-mb-3 tw-text-center" v-if="pageOptions.email">
                <h3 class="tw-font-sans tw-text-white tw-text-xl md:tw-text-2xl tw-font-extrabold tw-m-0 tw-mb-5">{{selectedLanguage == 'US' ? en.title_contact_me : pt.title_contact_me}}</h3>
                <a :href="'mailto:'+pageOptions.email" class="tw-text-gray-900 tw-font-sans tw-uppercase tw-font-medium tw-text-xs tw-bg-white tw-rounded tw-px-6 tw-py-3"><i class="fas fa-envelope tw-mr-2"></i> {{selectedLanguage == 'US' ? en.bt_contact_me : pt.bt_contact_me}}</a>
            </div>
            <div :class="{'md:tw-w-6/12': pageOptions.email}" class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center" v-if="pageOptions.contractor_email || pageOptions.contractor_phone">
                <h3 class="tw-font-sans tw-text-white tw-text-xl md:tw-text-2xl tw-font-extrabold tw-m-0 tw-mb-3">{{selectedLanguage == 'US' ? en.title_contractors : pt.title_contractors}}</h3>
                <div class="tw-font-sans tw-w-full">
                    <a :href="'mailto:'+pageOptions.contractor_email" class="tw-pb-3 tw-text-white"><i class="fas fa-envelope tw-mr-1"></i>{{pageOptions.contractor_email}}</a>
                    <p class="tw-mb-0 tw-mt-2"><i class="fas fa-phone tw-mr-1"></i>{{pageOptions.contractor_phone}}</p>
                </div>
            </div>
        </div>
    </section>
</section>
</template>

<script> 
import Layout from '@/Shared/Layout';
import Swiper from 'swiper';
import Single from '@/components/single';
import EventBus from '@/eventbus';
import pt from "../../../lang/smartsite/layout_1/layout_1.js";
import PlaylistList from '@/Pages/smartsite/layouts/components/version1/playlists';

require('readmore-js');
export default {
    mixins: [pt],
    layout: (h, page) => h(Layout, [page]),
    layout: Layout,
    props: ['artist', 'spotifyArtist', 'pageOptions', 'albums', 'singles', 'shows', 'playlists'],
    components: {Single, PlaylistList},
    metaInfo() {
        return { 
            title: `${this.beat.name}`,
        }
    },
    data(){
        return {
            loading: true,
            snackbar: false,
            snackbar_text: '',
            technical: false,
            technical_free: false,
            technical_password: '',
            press: false,
            press_free: false,
            press_password: '',
            isVideo: false,
            videos: [],
            playlist_loaded: false,
            selectedLanguageObj: {},
        }
    },
    computed: {
        selectedLanguage() { 
            return this.$page.props.lang
        }
    },
    created(){
        EventBus.$emit('artist', {'pageOptions': this.pageOptions, 'artist': this.artist, 'spotifyArtist': this.spotifyArtist, 'albums': this.albums, 'shows': this.shows, 'playlists': this.playlists});
    },
    methods: {
        addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        verifyPassword(val){
            axios.post(`/api/presskit/password/${this.pageOptions.id}`, {
                type: val,
                password: val == 'press' ? this.press_password : this.technical_password
            })
            .then(res => {
                if(res.data.password){
                    val == 'press' ? this.press_free = true : this.technical_free = true;
                } else {
                    this.snackbar = true;
                    this.snackbar_text = 'Senha incorreta!'
                }
            });
        },
        checkVideo(){
            let url = this.pageOptions ? this.pageOptions.featured_img : '';
            if(url){
                let extension = url.replace(/^.*\./, '');
                if(extension == 'mp4'){
                    return this.isVideo = true;
                } 
                return this.isVideo = false;
            }
        },
        async getVideos(){
            this.videos = [];
            const vm = this;
            let promises = [];
                
                async function getPlaylists(){
                    for(const playlist of vm.playlists){
                        axios.get('/api/youtube-playlist/load', {
                            params: {
                                'youtube_ids': playlist.youtube_id,
                            }
                        }).then(function(res) {
                                vm.videos.push({
                                    name: res.data.data.items[0].snippet.title,
                                    items: [],
                                });
                            },
                            function(err){ 
                                vm.loading = false;
                            }
                        );
                    }
                }

                async function listItems(){
                    for(const [i, playlist] of vm.playlists.entries()){
                        axios.get('/api/youtube-playlist/load-items', {
                            params: {
                                playlist_id: playlist.youtube_id 
                            }
                        }).then(function(res){
                            res.data.data.items.forEach(video => {
                                if(video.status.privacyStatus == 'public'){
                                    vm.videos[i].items.push(video);
                                }
                            });
                            vm.loading = false;
                        },
                            function(err) {
                                vm.loading = false;
                            }
                        );
                    }
                }
                
                getPlaylists().then(() => {
                    listItems();
                })
            
        },
        setLanguage() {
            if(this.$page.props.lang == 'US') {
                this.selectedLanguageObj = pt.data().en
            } else {
                this.selectedLanguageObj = pt.data().pt
            }
        }
    },
    mounted(){
        if(this.$page.props.lang == 'US') {
                var open = pt.data().en.open
                var close = pt.data().en.close
            } else {
                var open = pt.data().pt.open
                var close = pt.data().pt.close
            }
        this.checkVideo();
        const vm = this;
        vm.getVideos();
        var albunsSwiper = new Swiper('#albums .swiper-container', {
            slidesPerView: 1.25,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            observer: true,
            observeParents: true,
            observeSlideChildren:true,
            navigation: {
                nextEl: '#albums .swiper-button-next',
                prevEl: '#albums .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
        var musicSwiper = new Swiper('#musics .swiper-container', {
            slidesPerView: 2.25,
            slidesPerGroup: 1,
            spaceBetween: 15,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            observer: true,
            observeParents: true,
            observeSlideChildren:true,
            navigation: {
                nextEl: '#musics .swiper-button-next',
                prevEl: '#musics .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'row',
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'row',
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    spaceBetween: 20,
                },
                1280: {
                    slidesPerView: 5,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'row',
                    slidesPerGroup: 5,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    spaceBetween: 20,
                },
            },
        });
        $(document).ready(function () {
            $('#about .bio').readmore({
                moreLink: `<a href="#" class="readmore tw-font-sans tw-text-white tw-text-center tw-block md:tw-text-left">${open}</a>`,
                lessLink: `<a href="#" class="readmore--close tw-text-white tw-font-sans tw-text-center tw-block md:tw-text-left">${close}</a>`,
                collapsedHeight: 100, 
                beforeToggle: function(trigger, el, ex) {
                    if(ex){
                        $('#artist .bio').addClass('truncated')
                        $('#artist .bio').addClass('tw-overflow-hidden')
                        $('#artist .bio').removeClass('tw-overflow-y-auto')
                        setTimeout( function() {$('#artist .bio').scrollTop(0)}, 200 );;
                    } else {
                        $('#artist .bio').removeClass('tw-overflow-hidden')
                        $('#artist .bio').addClass('tw-overflow-y-auto')
                        $('#artist .bio').css({
                            'max-height': '400px'
                        });
                        $('#artist .bio').removeClass('truncated')
                    }
                } 
            });
        });
        this.setLanguage();
    },
    watch: {
        loading(newVal, oldVal){
            if(!newVal && Object.keys(this.videos).length){
                this.videos.forEach(function(playlist, index){ 
                    new Swiper(`#playlist${index} .swiper-container`, {
                        slidesPerView: 1.25,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                        slidesOffsetBefore: 15,
                        slidesOffsetAfter: 15,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren:true,
                        navigation: {
                            nextEl: `#playlist${index} .swiper-button-next`,
                            prevEl: `#playlist${index} .swiper-button-prev`,
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                            },
                            1024: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                            },
                            1280: {
                                slidesPerView: 4,
                                slidesPerGroup: 4,
                                slidesOffsetBefore: 0,
                                slidesOffsetAfter: 0,
                            },
                        },
                    });
                });
            }
        }
    }
}
</script>
<style scoped lang="scss">
#contact{
    background:#131313;
}
.single-slider{
    opacity: 0;
    transition: all .3s ease-in-out;
}
.swiper-slide:hover .single-slider{
    opacity: 1;
}
/* #artist::before{
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgb(0,0,0);
    background: -moz-linear-gradient(90deg, rgba(0,0,0,1) 38%, rgba(0,0,0,0) 68%);
    background: -webkit-linear-gradient(90deg, rgba(0,0,0,1) 38%, rgba(0,0,0,0) 68%);
    background: linear-gradient(90deg, rgba(0,0,0,1) 38%, rgba(0,0,0,0) 68%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
} */
#about .bio{
    transition: all 0.5s ease 0s;
}
#about .bio.truncated{
    -webkit-mask-image: -webkit-gradient(linear, left 50%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));
}
#about .bio.truncated::before{
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #eee;
}
#about{
    position: relative;
    height: auto;
    background-color: #000;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: 0.375rem;
    overflow: hidden;
}

#about .bio-height{
    max-height: 200px;
}

#about .background{
    height: 56.25vw;
    margin-bottom: -50px;
    position: relative;
    z-index: 0;
    overflow: hidden;
    background-color: #000;
    top: 0;
    width: 100%;
}
#about .background::before {
    display: block;
    content: "";
    position: absolute;
    width: calc(100% + 1px);
    height: calc(100% + 1px);
    z-index: 1;
    background-image: linear-gradient(180deg,transparent 60%,#000);
}
@media only screen and (min-width: 768px){
    #about{
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        height: auto;
        margin-left: 0;
        margin-right: 0;
        min-height: 33.75vw;
    }
    #about .background{
        position: absolute;
        top: 0;
        right: 0;
        width: 60%;
        height: 100%;
        margin-bottom: 0;
    }
    #about .background::before {
        background-image: linear-gradient(90deg,#000,transparent 40%,transparent);
    }
}
@media only screen and (min-width: 1024px){
    #about{
        min-height: 30.9vw;
    }
    #about .background{
        width: 55%;
    }
}

.event-wrapper{
    padding: 24px 0px;
    margin: 0px 24px 0px 0px;
    max-height: 300px;
    border-left: none;
}
.event-date {
    display: flex;
    margin-bottom: 8px;
    flex-flow: row wrap;
}
@media screen and (min-width: 768px){
    .event-date {
        margin-bottom: 0px;
        margin-right: 8px;
        width: 13ch;
        flex-flow: column nowrap;
    }
}
.event-details{
    display: grid;
    grid-template-areas: "header";
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    width: 100%;
}
.event-details__header{
    display: flex;
    flex-flow: row;
    grid-area: header / header / header / header;
}
.event-details__inner{
    max-height: 600px;
    opacity: 1;
    visibility: visible;
    transition: max-height 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s, opacity 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.2s, margin-bottom 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    align-items: flex-start;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    flex: 1 1 0%;
    flex-flow: row;
    max-width: 80vw;
}
@media(min-width:1280px){
    .event-details__inner{
        max-width: 950px;
    }
}
.right-actions{
    display: flex;
    padding-top: 24px;
    flex-shrink: 0;
    flex-flow: column;
}
.right-actions a{
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    text-align: center;
    font-weight: 600;
    line-height: 36px;
    margin-bottom: 4px;
    max-height: 36px;
    min-width: 106px;
    font-weight: 600;
    font-size: 14px;
    line-height: 2.43;
    width: 100%;
    min-width: 60px;
    text-align: center;
    text-transform: capitalize;
    cursor: pointer;
    color: rgb(255, 255, 255);
    background-color: rgb(2, 108, 223);
    display: block;
    padding: 0px 12px;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    border-image: initial;
    transition: background-color 0.3s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
    text-decoration: none;
}

.full {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

</style>